export default __webpack_public_path__ + "static/media/danhos-logo.354e67c7.jpeg";